
import {DojoDeshi} from './DojoDeshi.js';
import {DojoTemplates} from './DojoTemplates.js';
import {Eventify} from './Eventify.js';
import signals from './lib/signals.js';

export class ClassRecordTechniqueComponent {
	constructor(techniquesModel, technique, addToServer=false) {
		this.techniquesModel = techniquesModel;
		this.technique = technique;

		[this.el, this.$] = DojoTemplates('ClassRecordTechniqueComponent');
		this.$.Name.textContent = technique.Name;

		this.$.remove.addEventListener('click', (evt)=>{
			this.techniquesModel.removeTechnique(this.technique);
			this.el.remove();
		});
	}
	render() {
		return this.el;
	}
}

window.ClassRecordTechniqueComponent = ClassRecordTechniqueComponent;